<template>
    <v-container fluid>
        <v-row class="mt-8">
            <v-col md="2" class="hidden-sm-and-down">
                <v-banner sticky class="elevation-1" style="top: 60px">
                    <v-list dense nav>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#general'}">
                            {{ $t('travel.menu.general') }}
                        </v-list-item>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#arrival'}">
                            {{ $t('travel.menu.arrival-departure') }}
                        </v-list-item>
                        <!--
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#emergency'}">
                            {{ $t('travel.menu.emergency-contact') }}
                        </v-list-item>
                        -->
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#location'}">
                            {{ $t('travel.menu.location') }}
                        </v-list-item>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#similar'}">
                            {{ $t('travel.menu.similarTrips') }}
                        </v-list-item>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#trail'}">
                            {{ $t('travel.menu.hiking-trail') }}
                        </v-list-item>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#bikeTrail'}">
                            {{ $t('travel.menu.bike-trail') }}
                        </v-list-item>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#downloads'}">
                            {{ $t('travel.menu.Downloads') }}
                        </v-list-item>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#gpx'}">
                            {{ $t('travel.menu.GPX') }}
                        </v-list-item>
                        <v-list-item :to="{name: 'TripsDetailIntro', params: {id: trip.id}, hash: '#important'}">
                            {{ $t('travel.menu.importantInfo') }}
                        </v-list-item>
                    </v-list>
                </v-banner>
            </v-col>
            <v-col md="10">
                <v-card class="elevation-0 mb-6" id="general">
                    <v-card-title class="mb-4">
                        {{ $t('travel.menu.general') }}
                    </v-card-title>
                    <v-card-subtitle>
                        <v-divider></v-divider>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col md="6">
                                    <v-text-field :label="$t('travel.general.tourCode')"
                                                  v-model="trip.extCode"
                                                  disabled>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-text-field :label="$t('travel.general.ASICode')"
                                                  disabled
                                                  v-model="tripStore.code">
                                    </v-text-field>
                                    <v-btn
                                        tonal
                                        :href="`https://www.asi-reisen.de/r/${tripStore.code.toLowerCase()}`"
                                        target="_blank"
                                        :disabled="!trip._published"
                                    >
                                        {{ $t('travel.general.linkTo') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-hover
                                                v-if="!isUpdating && (trip.image && trip.image.path)"
                                            >
                                                <template
                                                    v-slot:default="{ hover }"
                                                >
                                                    <div
                                                        style="position:relative;"
                                                    >
                                                        <!--suppress HtmlUnknownTarget -->
                                                        <v-img
                                                            :src="trip.image.path"
                                                        />
                                                        <v-fade-transition>
                                                            <v-overlay
                                                                v-if="hover"
                                                                absolute
                                                                color="primary"
                                                                z-index="3"
                                                            >
                                                                <v-btn
                                                                    fab
                                                                    dark
                                                                    color="error"
                                                                    @click="removeImage"
                                                                >
                                                                    <v-icon
                                                                        dark
                                                                    >
                                                                        mdi-delete
                                                                    </v-icon>
                                                                </v-btn>
                                                            </v-overlay>
                                                        </v-fade-transition>
                                                    </div>
                                                </template>
                                            </v-hover>
                                            <v-skeleton-loader
                                                v-else-if="isUpdating"
                                                type="image"
                                                max-width="800"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="2" v-for="(image, idx) in tripData.images"
                                               :key="idx">

                                                <v-hover
                                                    v-if="!isUpdating && (tripData.images || trip._images !== null)"
                                                >
                                                    <template
                                                        v-slot:default="{ hover }"
                                                    >
                                                        <div
                                                            style="position:relative;"
                                                        >
                                                            <!--suppress HtmlUnknownTarget -->
                                                            <v-img
                                                                :src="image.src"
                                                                width="80"
                                                            />
                                                            <v-fade-transition>
                                                                <v-overlay
                                                                    v-if="hover"
                                                                    absolute
                                                                    color="primary"
                                                                    z-index="3"
                                                                >
                                                                    <v-btn
                                                                        fab
                                                                        dark
                                                                        color="error"
                                                                        @click="removeImage(image.id, idx)"
                                                                    >
                                                                        <v-icon
                                                                            dark
                                                                        >
                                                                            mdi-delete
                                                                        </v-icon>
                                                                    </v-btn>
                                                                </v-overlay>
                                                            </v-fade-transition>
                                                        </div>
                                                    </template>
                                                </v-hover>
                                                <v-skeleton-loader
                                                    v-else-if="isUpdating"
                                                    type="image"
                                                    max-width="80"
                                                />
                                        </v-col>
                                        <v-col cols="12">
                                            <upload
                                                v-model="trip._image"
                                                :accept="['image/*']"
                                                :regex="['image.*']"
                                                :preview="true"
                                                label="images"
                                                @input="$v.trip._image.$touch()"
                                                multiple
                                            >
                                            </upload>
                                        </v-col>
                                        <v-col cols="12">
                                            <span>{{ $t('travel.general.copyrightInfo') }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-textarea :label="$t('travel.general.description')"
                                                v-model="trip.description"
                                                @input="$v.trip.description.$touch()"
                                                @blur="$v.trip.description.$touch()">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-textarea :label="$t('travel.general.character')"
                                                v-model="trip.character"
                                                @input="$v.trip.character.$touch()"
                                                @blur="$v.trip.character.$touch()">
                                    </v-textarea>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-combobox v-model="trip.translatedHighlights"
                                                multiple
                                                deletable-chips
                                                small-chips
                                                :label="$t('travel.general.highlights')">
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <kbd>enter</kbd>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-combobox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card class="elevation-0 mb-6" id="arrival">
                    <v-card-title class="mb-4">{{ $t('travel.menu.arrival-departure') }}</v-card-title>
                    <v-card-subtitle>
                        <v-divider></v-divider>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col md="6">
                                    <v-text-field :label="$t('travel.arrivalDeparture.start')"
                                                  v-model="trip.start"
                                                  @input="$v.trip.start.$touch()"
                                                  @blur="$v.trip.start.$touch()">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-text-field :label="$t('travel.arrivalDeparture.end')"
                                                  v-model="trip.end"
                                                  @input="$v.trip.end.$touch()"
                                                  @blur="$v.trip.end.$touch()">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <airport-autocomplete
                                        :label="$t('travel.arrivalDeparture.airports')"
                                        v-model="trip.airports"
                                        @input="$v.trip.airports.$touch()"
                                        @blur="$v.trip.airports.$touch()">
                                    </airport-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-combobox v-model="trip.trainStations"
                                                multiple
                                                deletable-chips
                                                small-chips
                                                :label="$t('travel.arrivalDeparture.trainstations')"
                                                @input="$v.trip.trainStations.$touch()"
                                                @blur="$v.trip.trainStations.$touch()">
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <kbd>enter</kbd>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-combobox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-combobox v-model="trip.busStations"
                                                multiple
                                                deletable-chips
                                                small-chips
                                                :label="$t('travel.arrivalDeparture.buses')"
                                                @input="$v.trip.busStations.$touch()"
                                                @blur="$v.trip.busStations.$touch()">
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <kbd>enter</kbd>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-combobox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-combobox v-model="trip.parkingFacilities"
                                                multiple
                                                deletable-chips
                                                small-chips
                                                :label="$t('travel.arrivalDeparture.parking')"
                                                @input="$v.trip.parkingFacilities.$touch()"
                                                @blur="$v.trip.parkingFacilities.$touch()">
                                        <template v-slot:no-data>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <kbd>enter</kbd>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-combobox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-text-field v-model="trip.timeOfArrival"
                                                  :label="$t('travel.arrivalDeparture.timeArrival')"
                                                  @input="$v.trip.timeOfArrival.$touch()"
                                                  @blur="$v.trip.timeOfArrival.$touch()">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="6">
                                    <v-text-field v-model="trip.timeOfDeparture"
                                                  :label="$t('travel.arrivalDeparture.timeDeparture')"
                                                  @input="$v.trip.timeOfDeparture.$touch()"
                                                  @blur="$v.trip.timeOfDeparture.$touch()">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card class="elevation-0 mb-6" id="location">
                    <v-card-title class="mb-4">{{ $t('travel.menu.location') }}</v-card-title>
                    <v-card-subtitle>
                        <v-divider></v-divider>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="6">
                                    <country-autocomplete
                                        v-model="trip.countries"
                                        @input="$v.trip.countries.$touch()"
                                        @blur="$v.trip.countries.$touch()">
                                    </country-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <region-autocomplete
                                        v-model="trip.regions"
                                        @input="$v.trip.regions.$touch()"
                                        @blur="$v.trip.regions.$touch()">
                                    </region-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card class="elevation-0 mb-6" id="similar">
                    <v-card-title class="mb-4">{{ $t('travel.menu.similarTrips') }}</v-card-title>
                    <v-card-subtitle>
                        <v-divider></v-divider>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="6">
                                    <trip-autocomplete v-model="trip.similarTravels"
                                                       @input="$v.trip.similarTravels.$touch()"
                                                       @blur="$v.trip.similarTravels.$touch()">
                                    </trip-autocomplete>
                                    <v-list>
                                        <v-list-item v-for="(trip, key) in trip.similarTravels" :key="key">
                                            {{ (trip.extCode ? trip.extCode : trip.code) }} {{ trip.name }}
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card class="elevation-0 mb-6" id="trail">
                    <v-card-title class="mb-4">{{ $t('travel.menu.hiking-trail') }}</v-card-title>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="6">
                                <trail-autocomplete v-model="trip.trails"
                                                    @input="$v.trip.trails.$touch()"
                                                    @blur="$v.trip.trails.$touch()">
                                </trail-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                <v-card class="elevation-0 mb-6" id="bikeTrail">
                    <v-card-title class="mb-4">{{ $t('travel.menu.bike-trail') }}</v-card-title>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="6">
                                <bike-trail-autocomplete v-model="trip.bikeTrails"
                                                         @input="$v.trip.bikeTrails.$touch()"
                                                         @blur="$v.trip.bikeTrails.$touch()">
                                </bike-trail-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                <v-card class="elevation-0 mb-6" id="downloads">
                    <v-card-title class="mb-4">{{ $t('travel.menu.Downloads') }}</v-card-title>
                    <v-card-subtitle>
                        <v-divider></v-divider>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col>
                                    <p>{{ $t('travel.downloads.info') }}</p>
                                    <v-data-table :headers="fileHeaders" :items="downloads">
                                        <template v-slot:item.name="{item}">
                                            <span v-if="item.file">
                                                {{ item.file.name }}
                                            </span>
                                            <span v-else-if="item.name">
                                                {{ item.name }}
                                            </span>
                                        </template>
                                        <template v-slot:item.visibility="{item}">
                                            {{ getFileVisibilityLabel(item.visibility) }}
                                        </template>
                                        <template v-slot:item.actions="{item}">
                                            <v-icon small
                                                    class="mr-2"
                                                    @click="editDownload(item)"
                                                    v-if="item.id">
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon small
                                                    @click="deleteDownload(item)">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                    </v-data-table>
                                    <v-dialog v-model="downloadDialogDelete" max-width="600px">
                                        <v-card>
                                            <v-card-title class="headline">
                                            </v-card-title>
                                            <v-card-text>{{ $t('travel.downloads.delete') }}</v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text @click="closeDeleteDownloadDialog">{{
                                                        $t('cancel')
                                                    }}
                                                </v-btn>
                                                <v-btn color="secondary" @click="deleteDownloadConfirm">{{
                                                        $t('yes')
                                                    }}
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <v-dialog v-model="downloadDialog" persistent max-width="600px">
                                        <template v-slot:activator="{attrs, on}">
                                            <v-btn color="secondary" v-bind="attrs" v-on="on">
                                                <v-icon left>
                                                    mdi-plus
                                                </v-icon>
                                                {{ $t('add') }}
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title class="mb-4">
                                                <span class="headline">{{ $t('add') }}</span>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-form>
                                                    <form>
                                                        <v-container class="pa-0">
                                                            <v-row class="mt-4">
                                                                <v-col>
                                                                    <upload
                                                                        v-model="editedDownload.file"
                                                                        :accept="['text/plain', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
                                                                        :regex="['text/plain', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']"
                                                                        label="download"
                                                                        multiple
                                                                    >
                                                                    </upload>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="mt-4">
                                                                <v-col>
                                                                    <v-select v-model="editedDownload.visibility"
                                                                              :items="fileVisibilities"
                                                                              :label="$t('Visibility')"
                                                                              item-value="value"
                                                                              item-text="label">
                                                                    </v-select>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </form>
                                                </v-form>
                                                <ul
                                                    v-if="downloadFileErrors"
                                                    class="error--text"
                                                >
                                                    <li
                                                        v-for="(error, key) in downloadFileErrors"
                                                        :key="key"
                                                    >
                                                        {{ error }}
                                                    </li>
                                                </ul>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn text @click="closeDownloadDialog">{{ $t('close') }}</v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn color="secondary" @click="addDownload">{{ $t('save') }}</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card class="elevation-0 mb-6" id="gpx">
                    <v-card-title class="mb-4">{{ $t('travel.menu.GPX') }}</v-card-title>
                    <v-card-subtitle>
                        <v-divider></v-divider>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col>
                                    <p>{{$t('travel.GPX.info')}}</p>
                                    <v-data-table :headers="fileHeaders" :items="gpx">
                                        <template v-slot:item.name="{item}">
                                            <span v-if="item.file">
                                                {{ item.file.name }}
                                            </span>
                                            <span v-else-if="item.name">
                                                {{ item.name }}
                                            </span>
                                        </template>
                                        <template v-slot:item.visibility="{item}">
                                            {{ getFileVisibilityLabel(item.visibility) }}
                                        </template>
                                        <template v-slot:item.actions="{item}">
                                            <v-icon small
                                                    class="mr-2"
                                                    @click="editGpx(item)"
                                                    v-if="item.id">
                                                mdi-pencil
                                            </v-icon>
                                            <v-icon small
                                                    @click="deleteGpx(item)">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                    </v-data-table>
                                    <v-dialog v-model="gpxDialogDelete" max-width="600px">
                                        <v-card>
                                            <v-card-title class="headline">
                                            </v-card-title>
                                            <v-card-text>{{ $t('travel.downloads.delete') }}</v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn text @click="closeDeleteGpxDialog">{{ $t('cancel') }}</v-btn>
                                                <v-btn color="secondary" @click="deleteGpxConfirm">{{ $t('yes') }}</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                    <v-dialog v-model="gpxDialog" persistent max-width="600px">
                                        <template v-slot:activator="{attrs, on}">
                                            <v-btn color="secondary" v-bind="attrs" v-on="on">
                                                <v-icon left>
                                                    mdi-plus
                                                </v-icon>
                                                {{ $t('add') }}
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <v-card-title class="mb-4">
                                                <span class="headline">{{ $t('add') }}</span>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-form>
                                                    <form>
                                                        <v-container class="pa-0">
                                                            <v-row class="mt-4">
                                                                <v-col>
                                                                    <upload
                                                                        v-model="editedGpx.file"
                                                                        :accept="['application/gpx+xml']"
                                                                        :regex="['application/gpx+xml']"
                                                                        label="gpx file"
                                                                        multiple
                                                                    >
                                                                    </upload>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="mt-4">
                                                                <v-col>
                                                                    <v-select v-model="editedGpx.visibility"
                                                                              :items="fileVisibilities"
                                                                              :label="$t('Visibility')"
                                                                              item-value="value"
                                                                              item-text="label">
                                                                    </v-select>
                                                                </v-col>
                                                            </v-row>
                                                        </v-container>
                                                    </form>
                                                </v-form>
                                                <ul
                                                    v-if="gpxFileErrors"
                                                    class="error--text"
                                                >
                                                    <li
                                                        v-for="(error, key) in gpxFileErrors"
                                                        :key="key"
                                                    >
                                                        {{ error }}
                                                    </li>
                                                </ul>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn text @click="closeGpxDialog">{{ $t('close') }}</v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn color="secondary" @click="addGpx">{{ $t('save') }}</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card class="elevation-0 mb-6" id="important">
                    <v-card-title class="mb-4">{{ $t('travel.menu.importantInfo') }}</v-card-title>
                    <v-card-subtitle>
                        <v-divider></v-divider>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="6">
                                    <tiptap-vuetify
                                        v-model="trip.importantNotice"
                                        :extensions="editorExtensions"
                                        label="Specific requirements for the trip, no Wireless, etc."
                                        @input="$v.trip.importantNotice.$touch()"
                                        @blur="$v.trip.importantNotice.$touch()"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <slot name="footer" :validate="validateTrip"></slot>
    </v-container>
</template>

<script>
    import AirportAutocomplete from '../../Airport/Autocomplete';
    import CountryAutocomplete from '../../Country/Autocomplete';
    import RegionAutocomplete from '../../Region/Autocomplete';
    import TrailAutocomplete from '../../Trail/Autocomplete';
    import BikeTrailAutocomplete from '../../BikeTrail/Autocomplete';
    import TripAutocomplete from '../../Trip/Autocomplete';
    import {mapActions, mapGetters} from "vuex";
    import {validationMixin} from 'vuelidate';
    import {email, required} from "vuelidate/lib/validators";
    import {validFileSize, validFileType} from "@/utils/validators/file";
    import {TiptapVuetify, History, Italic, Bold, ListItem, BulletList, OrderedList, Paragraph} from 'tiptap-vuetify';
    import {SnackBarAction} from "@/store/snackbar/types";
    import requiredIf from "vuelidate/lib/validators/requiredIf";
    import Upload from "../../Upload/Upload";
    import axios from "axios";

    export default {
        mixins: [
            validationMixin,
        ],
        components: {
            Upload,
            AirportAutocomplete,
            CountryAutocomplete,
            RegionAutocomplete,
            TrailAutocomplete,
            BikeTrailAutocomplete,
            TripAutocomplete,
            TiptapVuetify,
        },
        created() {
            this.init();
        },
        data: () => ({
            trip: {},
            emergencyContacts: [],
            downloads: [],
            gpx: [],
            contactHeaders: [
                {
                    text: 'Name',
                    value: 'name'
                },
                {
                    text: 'E-Mail Address',
                    value: 'email'
                },
                {
                    text: 'Telephone Number',
                    value: 'telephone'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                }
            ],
            contactDialogDelete: false,
            contactDialog: false,
            editedContact: {
                firstname: '',
                lastname: '',
                email: '',
                telephone: '',
            },
            defaultContact: {
                firstname: '',
                lastname: '',
                email: '',
                telephone: '',
            },
            contactEditedIndex: -1,
            downloadEditedIndex: -1,
            downloadDialog: false,
            downloadDialogDelete: false,
            gpxEditedIndex: -1,
            gpxDialog: false,
            gpxDialogDelete: false,
            editedDownload: {
                file: null,
                visibility: '',
            },
            defaultDownload: {
                file: null,
                visibility: '',
            },
            editedGpx: {
                file: null,
                visibility: '',
            },
            defaultGpx: {
                file: null,
                visibility: '',
            },
            editorExtensions: [
                History,
                Italic,
                Bold,
                ListItem,
                BulletList,
                OrderedList,
                Paragraph,
            ],
        }),
        validations: {
            trip: {
                id: {},
                name: {},
                extName: {},
                code: {},
                extCode: {},
                _image: {
                    fileType: validFileType({
                        fileTypes: [
                            'image/jpeg',
                            'image/png',
                        ],
                        validNames: [
                            '.jpg',
                            '.jpeg',
                            '.png',
                        ],
                    }),
                    fileSize: validFileSize({
                        max: 5000000,
                    }),
                },
                _imageCopyright: {},
                description: {},
                character: {},
                start: {},
                end: {},
                airports: {},
                trainStations: {},
                busStations: {},
                parkingFacilities: {},
                timeOfArrival: {},
                timeOfDeparture: {},
                emergencyContacts: {},
                countries: {},
                regions: {},
                similarTravels: {},
                trails: {},
                bikeTrails: {},
                _downloads: {},
                _gpx: {},
                importantNotice: {}
            },
            editedContact: {
                firstname: {
                    required,
                },
                lastname: {
                    required,
                },
                email: {
                    required,
                    email,
                },
                telephone: {
                    required,
                },
            },
            editedDownload: {
                file: {
                    required: requiredIf(function() {
                        return !this.editedDownload.id;
                    }),
                    fileType: validFileType({
                        fileTypes: [
                            'application/pdf',
                            'text/plain',
                            'application/msword',
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        ],
                        validNames: [
                            '.pdf',
                            '.txt',
                            '.doc',
                            '.docx',
                        ],
                    }),
                    fileSize: validFileSize({
                        max: 5000000,
                    }),
                },
            },
            editedGpx: {
                file: {
                    required: requiredIf(function() {
                        return !this.editedGpx.id;
                    }),
                    fileType: validFileType({
                        fileTypes: [
                            'application/gpx+xml',
                            'application/xml',
                        ],
                        validNames: [
                            '.gpx',
                        ],
                    }),
                    fileSize: validFileSize({
                        max: 5000000,
                    }),
                },
            },
        },
        watch: {
            contactDialog(val) {
                val || this.closeContactDialog();
            },
            contactDialogDelete(val) {
                val || this.closeDeleteContactDialog();
            },
            downloadDialog(val) {
                val || this.closeDownloadDialog();
            },
            downloadDialogDelete(val) {
                val || this.closeDeleteDownloadDialog();
            },
            gpxDialog(val) {
                val || this.closeGpxDialog();
            },
            gpxDialogDelete(val) {
                val || this.closeDeleteGpxDialog();
            },
            watch: {
                activeVariant() {
                    this.init();
                },
            },
        },
        computed: {
            ...mapGetters({
                isLoading: 'trips/isLoading',
                isUpdating: 'trips/isUpdating',
                tripStore: 'trips/trip',
                variantData: 'trips/variantData',
                activeVariant: 'trips/activeVariant',
            }),
            fileHeaders() {
                return [
                    {
                        text: this.$t('Filename'),
                        value: 'name',
                    },
                    {
                        text: this.$t('Visibility'),
                        value: 'visibility',
                        width: 300,
                    },
                    {
                        text: this.$t('Actions'),
                        value: 'actions',
                        width: 100,
                    },
                ]
            },
            fileVisibilities() {
                return [
                    {
                        value: '',
                        label: this.$t("travel.file.visibility.public"),
                    },
                    {
                        value: 'intern',
                        label: this.$t("travel.file.visibility.internal"),
                    },
                ]
            },
            tripData() {
                if(this.variantData) {
                    return this.variantData;
                }

                return this.tripStore;
            },
            introProperties() {
                const {
                    id,
                    name,
                    extName,
                    code,
                    extCode,
                    image,
                    description,
                    character,
                    translatedHighlights,
                    start,
                    end,
                    airports,
                    trainStations,
                    busStations,
                    parkingFacilities,
                    timeOfArrival,
                    timeOfDeparture,
                    emergencyContacts,
                    countries,
                    regions,
                    similarTravels,
                    trails,
                    bikeTrails,
                    downloads,
                    gpx,
                    importantNotice,
                    _published,
                } = this.tripData;

                return {
                    id,
                    name,
                    extName,
                    code,
                    extCode,
                    image,
                    description,
                    character,
                    translatedHighlights,
                    start,
                    end,
                    airports,
                    trainStations,
                    busStations,
                    parkingFacilities,
                    timeOfArrival,
                    timeOfDeparture,
                    emergencyContacts,
                    countries,
                    regions,
                    similarTravels,
                    trails,
                    bikeTrails,
                    downloads,
                    gpx,
                    importantNotice,
                    _published,
                    _image: null,
                    _imageCopyright: image ? image.copyright : null,
                };
            },
            downloadFileErrors() {
                const errors = [];
                if(!this.$v.editedDownload.file.$dirty) {
                    return errors;
                }
                if(!this.$v.editedDownload.file.required) {
                    errors.push('File is required');
                }
                if(!this.$v.editedDownload.file.fileType) {
                    errors.push(`Valid files are: ${this.$v.editedDownload.file.$params.fileType.value.validNames.join(', ')}`);
                }
                if(!this.$v.editedDownload.file.fileSize) {
                    errors.push(`File size is to large, maximum, ${Math.floor(this.$v.editedDownload.file.$params.fileSize.value.max / 1000000)} MB`);
                }

                return errors;
            },
            gpxFileErrors() {
                const errors = [];
                if(!this.$v.editedGpx.file.$dirty) {
                    return errors;
                }
                if(!this.$v.editedGpx.file.required) {
                    errors.push('File is required');
                }
                if(!this.$v.editedGpx.file.fileType) {
                    errors.push(`Valid files are: ${this.$v.editedGpx.file.$params.fileType.value.validNames.join(', ')}`);
                }
                if(!this.$v.editedGpx.file.fileSize) {
                    errors.push(`File size is to large, maximum, ${Math.floor(this.$v.editedGpx.file.$params.fileSize.value.max / 1000000)} MB`);
                }

                return errors;
            },
            imageErrors() {
                const errors = [];
                if(!this.$v.trip._image.$dirty) {
                    return errors;
                }
                if(!this.$v.trip._image.fileType) {
                    errors.push(`Valid files are: ${this.$v.trip._image.$params.fileType.value.validNames.join(', ')}`);
                }
                if(!this.$v.trip._image.fileSize) {
                    errors.push(`File size is to large, maximum, ${Math.floor(this.$v.trip._image.$params.fileSize.value.max / 1000000)} MB`);
                }

                return errors;
            },
            base64Image() {
                if(this.trip._image) {
                    return URL.createObjectURL(Array.from(this.trip._image)[0]);
                }

                return this.trip.image.path;
            },
        },
        methods: {
            ...mapActions({
                setSnackbar: `snackbar/${SnackBarAction.SET}`,
            }),
            validateTrip(onSuccess, onError){
                if(!this.$v.trip.$invalid) {
                    onSuccess(this.trip, this.init);
                }else{
                    onError();
                }
            },
            init() {
                this.trip = this.introProperties;

                if(!this.trip.emergencyContacts) {
                    this.trip.emergencyContacts = [];
                }
                if(!this.trip.countries) {
                    this.trip.countries = [];
                }
                if(!this.trip.regions) {
                    this.trip.regions = [];
                }
                if(!this.trip.downloads) {
                    this.trip.downloads = [];
                }
                if(!this.trip.gpx) {
                    this.trip.gpx = [];
                }
                if(!this.trip.airports) {
                    this.trip.airports = [];
                }
                if(!this.trip.trainStations) {
                    this.trip.trainStations = [];
                }
                if(!this.trip.busStations) {
                    this.trip.busStations = [];
                }
                if(!this.trip.parkingFacilities) {
                    this.trip.parkingFacilities = [];
                }
                if(!this.trip.similarTravels) {
                    this.trip.similarTravels = [];
                }
                if(!this.trip.image) {
                    this.trip.image = {
                        file: null,
                        name: null,
                        path: null,
                        copyright: null,
                        id: null,
                    };
                }

                this.emergencyContacts = this.trip.emergencyContacts;
                this.downloads = this.trip.downloads;
                this.gpx = this.trip.gpx;
            },
            addContact() {
                this.$refs.contactForm.$v.data.$touch();
                this.$v.editedContact.$touch();
                if(
                    !this.$refs.contactForm.$v.data.$invalid &&
                    !this.$v.editedContact.$invalid
                ) {
                    if(this.contactEditedIndex > -1) {
                        Object.assign(this.emergencyContacts[this.contactEditedIndex], this.editedContact);
                    } else {
                        this.emergencyContacts.push(this.editedContact);
                    }
                    this.$v.trip.emergencyContacts.$touch();

                    this.closeContactDialog();
                }
            },
            closeContactDialog() {
                this.contactDialog = false;
                this.resetEditedContact();
            },
            closeDeleteContactDialog() {
                this.contactDialogDelete = false;
                this.resetEditedContact();
            },
            editContact(item) {
                this.contactEditedIndex = this.emergencyContacts.indexOf(item);
                this.editedContact = Object.assign({}, item);
                this.contactDialog = true;
            },
            deleteContact(item) {
                this.contactEditedIndex = this.emergencyContacts.indexOf(item);
                this.editedContact = Object.assign({}, item);
                this.contactDialogDelete = true;
            },
            deleteContactConfirm() {
                this.emergencyContacts.splice(this.contactEditedIndex, 1);
                this.$v.trip.emergencyContacts.$touch();
                this.closeDeleteContactDialog();
            },
            resetEditedContact() {
                this.$nextTick(function() {
                    this.editedContact = Object.assign({}, this.defaultContact);
                    this.contactEditedIndex = -1;
                    this.$v.editedContact.$reset();
                    this.$refs.contactForm.$v.data.$reset();
                });
            },
            addDownload() {
                this.$v.editedDownload.$touch();
                if(
                    !this.$v.editedDownload.$invalid
                ) {
                    if(this.downloadEditedIndex > -1) {
                        Object.assign(this.downloads[this.downloadEditedIndex], this.editedDownload);
                    } else {
                        Array.from(this.editedDownload.file).forEach(file=>{
                            this.downloads.push({
                                file: file,
                                visibility: this.editedDownload.visibility
                            });
                        });
                    }
                    this.$v.trip._downloads.$touch();

                    this.closeDownloadDialog();
                }
            },
            closeDownloadDialog() {
                this.downloadDialog = false;
                this.resetEditedDownload();
            },
            closeDeleteDownloadDialog() {
                this.downloadDialogDelete = false;
                this.resetEditedDownload();
            },
            editDownload(item) {
                this.downloadEditedIndex = this.downloads.indexOf(item);
                this.editedDownload = Object.assign({}, item);
                this.downloadDialog = true;
            },
            deleteDownload(item) {
                this.downloadEditedIndex = this.downloads.indexOf(item);
                this.editedDownload = Object.assign({}, item);
                this.downloadDialogDelete = true;
            },
            deleteDownloadConfirm() {
                this.downloads.splice(this.downloadEditedIndex, 1);
                this.$v.trip._downloads.$touch();
                this.closeDeleteDownloadDialog();
            },
            resetEditedDownload() {
                this.$nextTick(function() {
                    this.editedDownload = Object.assign({}, this.defaultDownload);
                    this.downloadEditedIndex = -1;
                    this.$v.editedDownload.$reset();
                });
            },
            addGpx() {
                this.$v.editedGpx.$touch();
                if(
                    !this.$v.editedGpx.$invalid
                ) {
                    if(this.gpxEditedIndex > -1) {
                        Object.assign(this.gpx[this.gpxEditedIndex], this.editedGpx);
                    } else {
                        Array.from(this.editedGpx.file).forEach(file=>{
                            this.gpx.push({
                                file: file,
                                visibility: this.editedGpx.visibility
                            });
                        });
                    }
                    this.$v.trip._gpx.$touch();

                    this.closeGpxDialog();
                }
            },
            closeGpxDialog() {
                this.gpxDialog = false;
                this.resetEditedGpx();
            },
            closeDeleteGpxDialog() {
                this.gpxDialogDelete = false;
                this.resetEditedGpx();
            },
            editGpx(item) {
                this.gpxEditedIndex = this.gpx.indexOf(item);
                this.editedGpx = Object.assign({}, item);
                this.gpxDialog = true;
            },
            deleteGpx(item) {
                this.gpxEditedIndex = this.gpx.indexOf(item);
                this.editedGpx = Object.assign({}, item);
                this.gpxDialogDelete = true;
            },
            deleteGpxConfirm() {
                this.gpx.splice(this.gpxEditedIndex, 1);
                this.$v.trip._gpx.$touch();
                this.closeDeleteGpxDialog();
            },
            resetEditedGpx() {
                this.$nextTick(function() {
                    this.editedGpx = Object.assign({}, this.defaultGpx);
                    this.gpxEditedIndex = -1;
                    this.$v.editedGpx.$reset();
                });
            },
            getFileVisibilityLabel(visibility) {
                for(let i = 0, l = this.fileVisibilities.length; i < l; i++) {
                    if(this.fileVisibilities[i].value === visibility) {
                        return this.fileVisibilities[i].label;
                    }
                }

                return '';
            },
            removeImage(image = null, index = null) {
                if(null === image){
                    this.trip.image = null;
                    this.trip._image = null;
                    this.trip._deleteImage = true;
                }else{
                    this.tripData.images.splice(index, 1);
                    axios.delete(`/trip/${this.trip.id}/image/${image}`)
                        .then(res=>{console.log(res)});
                }
            },
        },
        beforeRouteLeave(to, from, next) {
            if(this.$v.trip.$anyDirty) {
                let response = confirm(this.$t('unsavedChangesInfo'));
                next(response);
            } else {
                next();
            }
        },
    }
</script>
